// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dr","header":"ds","title":"dt","description":"du","button":"dv"};